import { useMemo } from 'react';
import { PredictionMarketConfigs } from './predictionMarketConfigs';

export const usePredictionMarketConfigs = () => {
	const predictionMarketConfigs = useMemo(
		() => PredictionMarketConfigs.getAllConfigs(),
		[PredictionMarketConfigs.configs]
	);

	return predictionMarketConfigs;
};
